<template>
    <div class="nskeleton">
        <template v-if="loading">
            <div
                class="nskeleton-item"
                :style="{ width: item.width, height: item.height }"
                v-for="item in ani"></div>
        </template>
        <slot v-else></slot>
    </div>
</template>
<script setup lang="ts">
withDefaults(
    defineProps<{
        loading: boolean;
        ani?: {
            width: string;
            height: string;
        }[];
    }>(),
    {
        loading: false,
        ani: () => []
    }
);
</script>
<style lang="scss" scoped>
@keyframes skeleton {
    0% {
        background-position: 100% 50%;
    }

    100% {
        background-position: 0 50%;
    }
}

.nskeleton-item {
    animation: skeleton 1.4s ease infinite;
    background-color: rgba(0, 0, 0, 0);
    background-position: left top;
    background-image: linear-gradient(90deg, rgba(204, 204, 204, 0.1) 25%, rgba(209, 209, 209, 0.5) 37%, rgba(200, 200, 200, 0.1) 63%) !important;
    background-size: 400% 100% !important;
    margin-bottom: 20px;
    border-radius: 10px;
}
</style>
